export default __webpack_public_path__ + "static/media/TV.964a31c4.PNG";